// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__VBfab","subheader":"ReorderModal_subheader__24Uxh","listWrap":"ReorderModal_listWrap__WG3eV"};